import React, { useReducer } from 'react';
import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import PageModel from '@mm/state/model/PageModel';

const reducer = (state, action) => {
  switch (action.type) {
    case 'busy':
      return {
        ...state,
        busy: action.payload,
      };
    case 'name':
      return {
        ...state,
        name: action.payload,
      };
    case 'edit': {
      const update = {
        ...state,
        edit: action.payload,
      };

      if (!action.payload) {
        update.name = state.dialogue?.name || '';
      }

      return update;
    }
    case 'dialogue':
      return {
        ...state,
        dialogue: action.payload,
      };
    default:
      return state;
  }
};

const initial: {
  busy: string;
  dialogue?: PageModel;
  edit: boolean;
  name: string;
  error: string;
} = {
  busy: '',
  error: '',
  dialogue: undefined,
  edit: false,
  name: '',
};

export const usePrimeState = ({ dialogueId }: { dialogueId?: number }) => {
  const [state, dispatch] = useReducer(reducer, initial);

  const pageCURDActions = usePageCRUDActions();
  const widgetCRUDActions = useWidgetCRUDActions();

  const changeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    dispatch({ type: 'name', payload: value });
  };

  const saveName = async () => {
    const { name, dialogue } = state;
    const { id, botId } = dialogue;
    if (name) {
      dispatch({ type: 'busy', payload: 'name' });
      try {
        const dialogue = await pageCURDActions.update({
          name: name.trim(),
          id,
          botId,
        });
        dispatch({ type: 'dialogue', payload: dialogue });
        dispatch({ type: 'edit', payload: false });
      } catch (err) {
        dispatch({ type: 'error', payload: 'name' });
      } finally {
        dispatch({ type: 'busy', payload: '' });
      }
    }
  };

  const init = async () => {
    if (dialogueId) {
      dispatch({ type: 'busy', payload: 'init' });

      try {
        const dialogue = await pageCURDActions.retrieveById(dialogueId);
        await widgetCRUDActions.retrieveAll(dialogueId, true);
        dispatch({ type: 'dialogue', payload: dialogue });
        dispatch({ type: 'name', payload: dialogue.name });
      } catch (err) {
        dispatch({ type: 'error', payload: 'init' });
      } finally {
        dispatch({ type: 'busy', payload: '' });
      }
    }
  };

  return [
    state,
    {
      init,
      edit: (payload: boolean) => dispatch({ type: 'edit', payload }),
      changeName,
      saveName,
    },
  ];
};
